import { useSelector } from "react-redux"
// import { mapStageToRoute } from "./../Components/customroutes"
// import { useRedirect, useAuthenticated } from "react-admin"
// import Parse from "./../Utils/index"
export const useRouteState = function () {
    const data = useSelector(state => state.router.location)
    return data
}

// export const ensureUserStage = function () {

//     // const user = useAuthenticated()
//     const redirect = useRedirect();
//     const stage = user.get('stage')
//     const route = mapStageToRoute(stage)
//     // redirect(route)
// } 